import styled from 'styled-components'
import colors from '../../../assets/colors'
import { headerStatStyles, chartWrapperStyles, noDataStyles } from '../dynamic-widget/styled'

export default styled.div`
  ${headerStatStyles}
  
  ${noDataStyles}

  ${chartWrapperStyles}

  .value-percent {
    font-weight: 600;
    font-size: 32px;
    line-height: 36px;
    color: ${props => props.theme.primary};
    text-align: center;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  .bottom-circle {
    position: absolute;
  }
  
  .label-stat {
    text-align: left;
    font-weight: 600;
    font-size: 14px;
    line-height: 20px;
    color: ${colors.blackAlpha80};
    padding: 24px 20px 0;
  }
`
